import { AfterViewInit, Component, ElementRef, EventEmitter, Inject, Output, ViewChild } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { USER_VALIDATION_ACTIONS, UserValidationActions } from '@/app/platform/platform-core/user/store/types';
import { EgiErrorCode } from '@data/_generated-api/error-mappers/egi-error-code';
import { Credentials } from '@/app/platform/platform-shared/models/credentials';

@Component({
    selector: 'credential-login',
    templateUrl: './credential-login.component.html',
    styleUrls: ['./credential-login.component.scss'],
    standalone: false
})
export class CredentialLoginComponent implements AfterViewInit {
  @Output() afterLogin = new EventEmitter<never>();

  @Output() emailChange = new EventEmitter<string>();
  @ViewChild('email') emailInputRef: ElementRef<HTMLElement>;

  constructor(
    @Inject(USER_VALIDATION_ACTIONS)
    private readonly validationActions: UserValidationActions,
    private readonly transloco: TranslocoService
  ) {}

  credentials = new Credentials('', '');
  isLoading = false;
  showPassword = false;
  emailErrorText = '';
  passwordErrorText = '';

  ngAfterViewInit() {
    this.emailInputRef.nativeElement.focus();
  }

  async login() {
    this.resetErrors();
    this.isLoading = true;
    const result = await this.validationActions.validateCredentials(this.credentials);
    this.isLoading = false;
    result.ifSuccess(() => {
      this.afterLogin.emit();
    });

    result.ifError(errors => {
      errors.forEach(e => {
        if (e.errorCode === EgiErrorCode.EmailNotFound) {
          this.emailErrorText = this.transloco.translate('account.login.errors.emailNotFound');
        }

        if (
          [
            EgiErrorCode.PasswordNotSet,
            EgiErrorCode.EmailPasswordCombinationInvalid,
            EgiErrorCode.PasswordInvalid
          ].includes(e.errorCode)
        ) {
          this.passwordErrorText = this.transloco.translate('account.login.errors.passwordInvalid');
        }

        // Enkel na een juist wachtwoord (issue #55): de eigenaar hoort dat een beheerder het terugzet
        if (e.errorCode === EgiErrorCode.UserAccountSoftDeleted) {
          this.passwordErrorText = this.transloco.translate('account.login.errors.deactivated');
        }
      });
    });
  }

  private resetErrors(): void {
    this.emailErrorText = '';
    this.passwordErrorText = '';
  }
}
